import { gql, useLazyQuery } from '@apollo/client';

interface CustomAttribute {
  id: string;
  name: string;
  value: string;
  type: string;
  updated_at?: string;
}

interface MediaMessage {
  _id: string;
  conversation_id: string;
  agent_id: string;
  person_channel_id: string;
  media: {
    type: string;
    url: string;
    media_id: string;
  };
  created_at: string;
  updated_at?: string;
}

interface Customer {
  _id: string;
  name: string;
  email?: string;
  phone?: string;
  created_at: string;
  last_activity?: string;
  custom_attributes?: CustomAttribute[];
}

interface CustomerWithPersonId {
  _id: string;
  person_id: string;
  name: string;
  email?: string;
  phone?: string;
  created_at: string;
  updated_at?: string;
  last_activity?: string;
  custom_attributes?: CustomAttribute[];
}

export type { CustomAttribute, Customer, CustomerWithPersonId, MediaMessage };

export const GET_CUSTOMERS = gql`
  query get_customers($data: GetCustomersInputType) {
    get_customers(data: $data) {
        hasError
        data
        message
    }
}
`;

export const GET_CUSTOMERS_BY_PERSON_ID = gql`
  query get_customers_by_person_id($data: GetCustomersByPersonIdInputType) {
    get_customers_by_person_id(data: $data) {
        hasError
        data
        message
    }
}
`;

export const GET_MEDIA_MESSAGES = gql`
  query get_media_messages($data: GetMediaMessagesInputType) {
    get_media_messages(data: $data) {
        hasError
        data
        message
    }
}
`;


export function useGetCustomers() {
  return useLazyQuery(GET_CUSTOMERS);
}

export function useGetCustomersByPersonId() {
  return useLazyQuery(GET_CUSTOMERS_BY_PERSON_ID);
}

export function useGetMediaMessages() {
  return useLazyQuery(GET_MEDIA_MESSAGES);
}
